var React = require('react');

function IconLiner (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M2.61261 16.2358C2.17266 18.2234 3.6282 20.1751 5.53394 20.1751C7.42641 20.1751 8.85562 18.2603 8.40344 16.3047C8.05588 14.8016 7.76885 13.1442 7.76885 11.7416C7.76885 10.044 8.19182 7.6145 8.63834 5.50825C9.05785 3.52944 7.57765 1.64136 5.61214 1.64136C3.60014 1.64136 2.07579 3.63468 2.51569 5.6958C2.90284 7.50977 3.23506 9.56998 3.23506 11.3249C3.23506 12.9327 2.95659 14.6818 2.61261 16.2358Z","stroke":"#001D3B","strokeWidth":"1.46621"}));
}

IconLiner.defaultProps = {"width":"11","height":"21","viewBox":"0 0 11 21","fill":"none"};

module.exports = IconLiner;

IconLiner.default = IconLiner;
